import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminAdResponse, AdResponse, PageResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class AdAdminService {
  private http = inject(HttpClient);
  private base = `${environment.apis.ads}/admin/ads`;

  /** status omis → toutes les publicités, toutes annonceurs confondus. */
  getAds(page = 0, size = 20, status?: string): Observable<PageResponse<AdminAdResponse>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (status) params = params.set('status', status);
    return this.http.get<PageResponse<AdminAdResponse>>(this.base, { params });
  }

  /** Refusé côté serveur si paymentStatus !== 'PAID' — l'UI doit filtrer l'action en amont. */
  validateAd(id: string): Observable<AdResponse> {
    return this.http.patch<AdResponse>(`${this.base}/${id}/validate`, {});
  }

  /** Renvoie l'annonce en DRAFT (pas un état terminal) — l'annonceur corrige et resoumet sans repayer. */
  rejectAd(id: string, reason: string): Observable<AdResponse> {
    return this.http.patch<AdResponse>(`${this.base}/${id}/reject`, { reason });
  }

  getPhotoUrl(documentId: string): Observable<string> {
    return this.http.get(`${environment.apis.document}/documents/${documentId}/photo-url`, { responseType: 'text' });
  }
}
